import { render, staticRenderFns } from "./StatementItem.vue?vue&type=template&id=ddfc68c4&scoped=true&"
import script from "./StatementItem.vue?vue&type=script&lang=js&"
export * from "./StatementItem.vue?vue&type=script&lang=js&"
import style0 from "./StatementItem.vue?vue&type=style&index=0&id=ddfc68c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfc68c4",
  null
  
)

export default component.exports